import { render, staticRenderFns } from "./wage-en.vue?vue&type=template&id=2bcf5403&"
import script from "./wage-en.vue?vue&type=script&lang=js&"
export * from "./wage-en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports